const login =
  '가입되지 않은 이메일이거나 비밀번호가 일치하지 않습니다. 계정 관련 문의는 사이트 오른쪽 하단의 채널톡으로 문의해주세요.';
const service =
  '일시적인 오류로 서비스 접속에 실패했습니다. 새로고침 후 다시 시도해주세요. 새로고침 후에도 실패한 경우 채널톡으로 문의해주세요.';
const sendChatMessage = '채팅 전송에 실패했습니다. 다시 시도해주세요.';
const readAnnotation = '주석 읽음처리에 실패했습니다.';
const createAnnotation = '주석 작성에 실패했습니다.';
const notOpendChatroomCreateAnnotationComment = '이미 종료된 상담입니다.';
const updateAnnotation = '주석 수정에 실패했습니다.';
const deleteAnnotation = '주석 삭제에 실패했습니다.';
const createComment = '답글 작성에 실패했습니다.';
const updateComment = '답글 수정에 실패했습니다.';
const deleteComment = '답글 삭제에 실패했습니다.';
const updateBypassComplaint =
  '불편사항 접수처리에 실패했습니다. 다시 시도해주세요.';
const notBypass = '처리에 실패했습니다. 다시 시도해주세요';
const commonException =
  '예상치못한 문제가 발생했습니다. 채널톡을 통해 문의해주세요.';

export default {
  login,
  service,
  readAnnotation,
  sendChatMessage,
  createAnnotation,
  updateAnnotation,
  deleteAnnotation,
  createComment,
  updateComment,
  deleteComment,
  updateBypassComplaint,
  notBypass,
  notOpendChatroomCreateAnnotationComment,
  commonException
};
